import * as React from 'react';
import { useField } from 'informedv4';
import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import 'react-datepicker/dist/react-datepicker.min.css';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { Required } from '../validation/Required';
import { DatePicker } from './DatePickerV4';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { DatePickerAcceptDateRange } from '../informedv4/DatePickerV4';

interface ConfigFieldDatePickerProps {
    id: string;
    field: string;
    name: string;
    className: string;
    disabled?: boolean;
    required: boolean;
    onBlur?: (value: string) => void;
    itemId: ConfigurableDataItemIds;
    includeTime?: boolean;
    acceptDateRange?: DatePickerAcceptDateRange;
    placeholder?: string;
}

export const ConfigFieldDatePicker = (props: ConfigFieldDatePickerProps): JSX.Element => {
    const {
        id,
        field,
        name,
        className,
        disabled,
        required,
        onBlur,
        itemId,
        placeholder
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();
    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    const { fieldState, fieldApi } = useField({ name: field, validate: item.importanceId === DataItemImportance.Mandatory ? Required : undefined });

    const { setValue } = fieldApi;

    if (dataItemConfigurationCollection === null)
        throw 'Fields Configurations is not set';

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <DatePicker
                name={name}
                id={id}
                label={item.displayText}
                fieldState={fieldState}
                fieldApi={fieldApi}
                setValue={setValue}
                className={className}
                disabled={disabled}
                required={required}
                onBlur={onBlur}
                includeTime={props.includeTime}
                acceptDateRange={props.acceptDateRange}
                placeholder={placeholder}
            />
        </Condition>
    </>
}
